import React from "react";
import { Box, Flex, Icon, IconButton, Text, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { MdSpeed, MdRefresh } from "react-icons/md";

/**
 * Renders the header section of the ElasticPerformanceBanner.
 * Includes the title, subtitle, speed icon badge, and a refresh button.
 * @param {object} props
 * @param {Function} props.onRefresh - Callback invoked when the refresh button is clicked.
 * @returns {React.ReactElement}
 */
function PerformanceBannerHeader({ onRefresh }) {
    const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Flex align="center" justify="space-between" mb="16px">
            <Flex align="center" gap="12px">
                <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg}>
                    <Icon as={MdSpeed} w="24px" h="24px" color="brand.500" />
                </Flex>
                <Box>
                    <Text fontSize="lg" fontWeight="700" color={titleColor}>Performance ElasticSearch</Text>
                    <Text fontSize="sm" color={subColor}>Response time and statistics</Text>
                </Box>
            </Flex>
            <Tooltip label="Refresh" placement="top" hasArrow>
                <IconButton aria-label="Refresh performance" icon={<Icon as={MdRefresh} />}
                    onClick={onRefresh} variant="ghost" size="sm" />
            </Tooltip>
        </Flex>
    );
}

export default PerformanceBannerHeader;
